// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<path d="M13.0992299,0.544483983 C13.7640042,-0.179555219 14.8327938,-0.18214123
				15.4975681,0.540626882 C16.1623022,1.26470991 16.1646361,2.42240998 15.5212296,
				3.11931799 L6.92222123,15.459148 C6.59872725,15.811503 6.17096994,16.0025171
				5.7254263,15.9999749 C5.27867544,16.001246 4.84975116,15.8102319 4.5037627,
				15.4320607 L0.499865788,10.0823494 C-0.164868261,9.35831018 -0.167202214,
				8.19412317 0.496364858,7.47008397 C1.16109891,6.74604477 2.2239732,6.74345876
				2.89462261,7.47394107 L5.71951094,11.4659528 L13.0992299,0.544483983 Z" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Tick.js